'use strict';

module.exports = {
  FACEBOOK: 1,
  LINKEDIN: 2,
  TWITTER: 3,
  GOOGLE: 4
};